import { Nillable } from '@web/utils';
import { PublicProductSortType } from '../enums/public-product-sort-type';

export class PublicProductsQuery {
  public constructor(
    private readonly data: {
      sortType?: Nillable<PublicProductSortType>;
      phrase?: Nillable<string>;
    },
  ) {}

  public get sortType(): Nillable<PublicProductSortType> {
    return this.data.sortType;
  }

  public get phrase(): Nillable<string> {
    return this.data.phrase;
  }
}
